import SignaturePad from "signature_pad";

Alpine.directive("signature", (el, { expression, modifiers }, { evaluate }) => {
    const options = expression ? evaluate(expression) : {};
    const initialValue = Alpine.bound(el, "value");

    const canvas = el.nodeName === "CANVAS" ? el : el.querySelector("canvas");
    const signaturePad = new SignaturePad(canvas, {
        ...options,
    });

    resizeCanvas(canvas);

    signaturePad.addEventListener(
        "beginStroke",
        () => {
            el.dispatchEvent(new CustomEvent("begin-stroke"));
        },
        { once: true },
    );

    signaturePad.addEventListener("endStroke", () => {
        if (signaturePad.isEmpty()) {
            el.value = "";
            el.dispatchEvent(new Event("input", { bubbles: true }));
            el.dispatchEvent(new CustomEvent("empty-stroke"));

            return;
        }

        const data = signaturePad.toData();
        const dataToPath = data.flatMap((stroke, strokeIndex) => {
            const points = stroke.points.flatMap((point) => [
                Math.max(0, Math.round(point.x)),
                Math.max(0, Math.round(point.y)),
            ]);

            return strokeIndex < data.length - 1 ? [...points, null] : points;
        });

        el.dispatchEvent(
            new CustomEvent("end-stroke", { detail: { path: dataToPath } }),
        );

        el.value = dataToPath;
        el.dispatchEvent(new Event("input", { bubbles: true }));
    });

    window.addEventListener("reset-signature", () => {
        const initialValue = Alpine.bound(el, "value");
        signaturePad.clear();

        if (initialValue) {
            el.value = "";
            el.dispatchEvent(new Event("input", { bubbles: true }));
        }
    });
});

function resizeCanvas(canvas) {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    const reDimension = () => {
        const rect = canvas.getBoundingClientRect();

        canvas.width = rect.width * ratio;
        canvas.height = rect.height * ratio;

        canvas.getContext("2d").scale(ratio, ratio);
    };

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                reDimension();
            }
        },
        { threshold: 0.01 },
    );

    observer.observe(canvas);
    reDimension();
}
